import DynamicIcon from "../ui/dynamic-icon";
import icon from "../ui/icon";
import SearchItem from "../ui/search-item";
import SearchModalSection from "../ui/search-modal-section";
import SearchModal from "./search-modal";

const GeneralSearchModal = ({ toggleModal, isOpen }) => {
  const filter = [
    { name: "People", icon: 'users-round' },
    { name: "Thread", icon: "link" },
    { name: "Link", icon: "link" },
    { name: "File", icon: "file" },

  ]

  const smartPrompts = [
    "Summarize my last 5 emails",
    "Compose an email to Alex about our Q2 report",
    "Find the email with the invoice John sent in April"
  ]

  const quickActions = [
    { name: "Compose Mail", icon: "pen-line" },
    { name: "Open personal settings", icon: "settings" },
    { name: "View unread", icon: "mail-plus" },
    { name: "Open draft", icon: "folder-open" }
  ]

  return (
    <SearchModal toggleModal={toggleModal} isOpen={isOpen}>
      <div className="grid gap-[24px] ">
        <SearchModalSection title='I&apos;m Searching for'>
          <div className="flex items-start gap-[12px]">
            {filter.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-[8px] text-[13px] poppins-medium custom-text-grey-900 cursor-pointer p-[10px] rounded-[8px] border-[1px] custom-border-white-200">
                <DynamicIcon name={item.icon} size={16} />
                {item.name}
              </div>
            ))}
          </div>
        </SearchModalSection>
        <SearchModalSection title='Smart Prompt'>
          <div className="grid gap-[12px]">
            {smartPrompts.map((prompt, index) => (
              <SearchItem key={index} isPrompt>{prompt}</SearchItem>
            ))}
          </div>
        </SearchModalSection>
        <SearchModalSection title='Quick Actions'>
          <div className="grid gap-[12px]">
            {quickActions.map((action, index) => (
              <SearchItem key={index} icon={action.icon}>
                {action.name}
              </SearchItem>
            ))}
          </div>
        </SearchModalSection>
      </div>
    </SearchModal>
  );
}
export default GeneralSearchModal;